import { C } from '../data/tokens.js';
import { Ico } from './Ico.jsx';

export function Header({ screen, go, subscription }) {
  const showBack = ["step1", "step2", "analyze", "review", "preview", "buy", "tierselect", "attachclient", "reportdetail", "settings", "profile", "clientdetail"].includes(screen);

  const backTarget = screen === "step1" ? "dashboard" : screen === "step2" ? "step1" :
    screen === "analyze" ? "step2" : screen === "review" ? "step2" :
    screen === "preview" ? "review" : screen === "tierselect" ? "review" :
    screen === "attachclient" ? "tierselect" :
    screen === "reportdetail" ? "dashboard" :
    screen === "settings" ? "profile" :
    screen === "profile" ? "dashboard" :
    screen === "clientdetail" ? "clients" :
    "dashboard";

  const statusLabel = subscription?.status === "trial" ? "Trial" :
    subscription?.status === "active" ? (subscription.plan === "premium" ? "Premium" : "Pro") :
    subscription?.status === "paused" ? "Paused" : null;

  return (
    <div className="hdr">
      <div className="hdr-l">
        {showBack && (
          <button className="back-btn" onClick={() => go(backTarget, "back")} type="button">
            <Ico n="arrowL" size={14} color={C.muted} />
          </button>
        )}
        <div className="wm">Mow<em>Rate</em></div>
      </div>
      <div className="hdr-r">
        {screen !== "signup" && screen !== "onboarding" && (
          <>
            {statusLabel && (
              <div style={{
                background: subscription.status === "active" ? `${C.teal}15` : subscription.status === "trial" ? `${C.gold}15` : C.bg2,
                border: `1px solid ${subscription.status === "active" ? `${C.teal}30` : subscription.status === "trial" ? `${C.gold}30` : C.border}`,
                borderRadius: 100, padding: "4px 12px",
                fontSize: 11, fontWeight: 700, color: subscription.status === "active" ? C.teal : subscription.status === "trial" ? C.gold : C.ghost,
                fontFamily: "'IBM Plex Mono',monospace",
              }}>
                {statusLabel}
              </div>
            )}
            <button type="button" style={{ width: 32, height: 32, borderRadius: 9, background: screen === "profile" ? C.bg2 : C.bg1, border: `1px solid ${screen === "profile" ? C.gold + "40" : C.border}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
              onClick={() => go("profile")}>
              <Ico n="user" size={14} color={screen === "profile" ? C.gold : C.muted} />
            </button>
            <button type="button" style={{ width: 32, height: 32, borderRadius: 9, background: screen === "settings" ? C.bg2 : C.bg1, border: `1px solid ${screen === "settings" ? C.gold + "40" : C.border}`, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
              onClick={() => go("settings")}>
              <Ico n="settings" size={14} color={screen === "settings" ? C.gold : C.muted} />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
